import { render, staticRenderFns } from "./BindsEditIcon.vue?vue&type=template&id=6daf4860&"
import script from "./BindsEditIcon.vue?vue&type=script&lang=js&"
export * from "./BindsEditIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports